import { render } from "./Beneficiarios.vue?vue&type=template&id=3bf77f88"
import script from "./Beneficiarios.vue?vue&type=script&lang=js"
export * from "./Beneficiarios.vue?vue&type=script&lang=js"

import "./Beneficiarios.vue?vue&type=style&index=0&id=3bf77f88&lang=css"
import "./Beneficiarios.vue?vue&type=style&index=1&id=3bf77f88&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__